// Create your feature flags here

/*
    Cookie-based feature flags
*/

// Flag to display the external apps incident statuses table
export const INCIDENTS = 'incidents';

// Flag to display the Unified Agent
export const UNIFIED_AGENT = 'unifiedAgent';

// Flag for showing/hiding the react-query devtools
export const REACT_QUERY_DEV_TOOLS = 'showReactQuery';

/*
 TenantSettings-based feature flags
 These are feature flags that are enabled/disabled through saving a flag as a key in the backend TenantSettings table.
*/

export const FEATURE_FLAGS_FROM_TENANT_SETTINGS = [];
